<template>
  <el-menu
    default-active="1"
    class="el-menu-vertical"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b">
    <el-menu-item index="1" @click="goToHome">
      <i class="el-icon-s-home"></i>
      <span>首页</span>
    </el-menu-item>
    <el-menu-item index="2" @click="goToAes">
      <i class="el-icon-lock"></i>
      <span>AES加密</span>
    </el-menu-item>
    <el-menu-item index="3" @click="goToSnowflake">
      <i class="el-icon-data-analysis"></i>
      <span>雪花算法</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "Aside",
  methods: {
    goToHome() {
      this.$router.push('/spa/home')
    },
    goToAes() {
      this.$router.push('/spa/aes')
    },
    goToSnowflake() {
      this.$router.push('/spa/snowflake')
    }
  }
}
</script>

<style scoped>
.el-menu-vertical {
  height: 100%;
  border-right: none;
}
</style>